import React from 'react';

import SignInButton from '../../components/buttons/SignInButton';

function LandingCta({ className = '', children }) {
  return <div className={`row mt-4 ${className}`.trim()}><div className="col-12 text-center">{children || <SignInButton />}</div></div>;
}

export default LandingCta;
